import Action from '../action';

export const NOTIFICATION_CHECK_SUPPORT = 'NOTIFICATION_CHECK_SUPPORT';
export const NOTIFICATION_DISMISS_TYPE = 'NOTIFICATION_DISMISS_TYPE';

export const checkBrowserSupportNotification = visible => Action(NOTIFICATION_CHECK_SUPPORT, visible);
export const dismissNotification = () => Action(NOTIFICATION_DISMISS_TYPE);
